import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { CopyIcon, UploadIcon } from "@gemini/icons";
import { useShare, useFeatureEnabled, useIsDesktopOrMobile } from "@/hooks";
import { useConfig } from "@/contexts/cdpConfig";
import { PrintCTA } from "./components/PrintCTA";
import { ShareCTA } from "./components/ShareCTA";
import { FavoriteCTA } from "./components/FavoriteCTA";
export const SocialAndPrintCTAs = ({ dark, showPrint = false, showBorder = false, }) => {
    const { copyShare, nativeMobileShare } = useShare();
    const favoriteEnabled = useFeatureEnabled("favorites");
    const isPreviewMode = useConfig().previewMode;
    const { isDesktopCSR } = useIsDesktopOrMobile();
    return (_jsxs(Box, { display: "flex", gap: isDesktopCSR ? "spacing.8" : null, height: "sizing.40", minWidth: {
            "breakpoint.base": "sizing.80",
            "breakpoint.lg": showPrint ? "sizing.142" : "sizing.96",
        }, alignItems: "flex-start", justifyContent: "right", id: "favoriteAndShareCTAs", marginLeft: "auto", children: [showPrint && isDesktopCSR && _jsx(PrintCTA, { dark: dark }), _jsx(ShareCTA, { onPress: isDesktopCSR ? copyShare : nativeMobileShare, icon: isDesktopCSR ? CopyIcon : UploadIcon, showBorder: showBorder, dark: dark }), favoriteEnabled && !isPreviewMode && (_jsx(FavoriteCTA, { dark: dark, showBorder: isDesktopCSR ? showBorder : false }))] }));
};
